/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface ActiveSeasonRow
 */
export interface ActiveSeasonRow {
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof ActiveSeasonRow
     */
    id: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {string}
     * @memberof ActiveSeasonRow
     */
    name: string;
    /**
     * 
     * @type {Date}
     * @memberof ActiveSeasonRow
     */
    startDate: Date;
    /**
     * 
     * @type {Date}
     * @memberof ActiveSeasonRow
     */
    endDate: Date;
    /**
     * 
     * @type {boolean}
     * @memberof ActiveSeasonRow
     */
    isCurrent: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ActiveSeasonRow
     */
    isUpcoming: boolean;
}

/**
 * Check if a given object implements the ActiveSeasonRow interface.
 */
export function instanceOfActiveSeasonRow(value: object): value is ActiveSeasonRow {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('startDate' in value) || value['startDate'] === undefined) return false;
    if (!('endDate' in value) || value['endDate'] === undefined) return false;
    if (!('isCurrent' in value) || value['isCurrent'] === undefined) return false;
    if (!('isUpcoming' in value) || value['isUpcoming'] === undefined) return false;
    return true;
}

export function ActiveSeasonRowFromJSON(json: any): ActiveSeasonRow {
    return ActiveSeasonRowFromJSONTyped(json, false);
}

export function ActiveSeasonRowFromJSONTyped(json: any, ignoreDiscriminator: boolean): ActiveSeasonRow {
    if (json == null) {
        return json;
    }
    return {
        
        'id': ApiUserTasksGetPageParameterFromJSON(json['id']),
        'name': json['name'],
        'startDate': (new Date(json['startDate'])),
        'endDate': (new Date(json['endDate'])),
        'isCurrent': json['isCurrent'],
        'isUpcoming': json['isUpcoming'],
    };
}

export function ActiveSeasonRowToJSON(json: any): ActiveSeasonRow {
    return ActiveSeasonRowToJSONTyped(json, false);
}

export function ActiveSeasonRowToJSONTyped(value?: ActiveSeasonRow | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': ApiUserTasksGetPageParameterToJSON(value['id']),
        'name': value['name'],
        'startDate': value['startDate'].toISOString().substring(0,10),
        'endDate': value['endDate'].toISOString().substring(0,10),
        'isCurrent': value['isCurrent'],
        'isUpcoming': value['isUpcoming'],
    };
}

